import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerInterface } from '@monsido/modules/models/api/interfaces/customer.interface';
import { FormBuilderInputModule, FormBuilderSelectModule, FormBuilderValidationModule, MonSwitchModule } from '@monsido/angular-shared-components';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from 'app/modules/translate.module';
import { EmailValidatorService } from '@monsido/modules/utils/email-validator.service';
import { MonsidoDirectiveModule } from 'app/directives/directives.module';

@Component({
    selector: 'mon-form-customer-detail',
    imports: [
        CommonModule,
        FormBuilderInputModule,
        FormBuilderSelectModule,
        FormBuilderValidationModule,
        FormsModule,
        MonSwitchModule,
        TranslateModule,
        MonsidoDirectiveModule,
    ],
    templateUrl: './mon-form-customer-detail.component.html',
    styleUrls: ['./mon-form-customer-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonFormCustomerDetailComponent implements AfterViewInit, OnInit {

    @Input() customer: CustomerInterface;
    @Input() isCreating: boolean = false;
    @Output() monFormValidityChanges: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('customerDetail', { static: false }) customerDetail: NgForm;

    private formValid?: boolean;
    emailValidatorRegex: RegExp;
    uuidRegex = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
    onHoldReportEmailsInput: string = '';

    constructor (
        private readonly emailValidatorService: EmailValidatorService,
    ) {}

    ngOnInit (): void {
        this.emailValidatorRegex = new RegExp(this.emailValidatorService.getEmailPattern());

        this.onHoldReportEmailsInput = Array.isArray(this.customer?.subscription?.on_hold_report_emails)
            ? this.customer.subscription.on_hold_report_emails.join(', ')
            : '';
    }

    onEmailInputChange (): void {
        if (this.customer?.subscription) {
            this.customer.subscription.on_hold_report_emails = this.onHoldReportEmailsInput
                .split(',')
                .map(e => e.trim())
                .filter(e => e);
        }
    }

    ngAfterViewInit (): void {
        this.customerDetail.form.valueChanges.subscribe(() => {
            if (this.formValid !== this.customerDetail.valid) {
                this.formValid = this.customerDetail.valid;
                this.monFormValidityChanges.emit(this.customerDetail.valid);
            }
        });
    }
}
